export default "__VITE_ASSET__CIfMVAjB__"